import { constants, typographyStyles } from "@newsela/angelou";

const { textSObj } = typographyStyles;

const neutral500 = constants.colors.ui.neutral[500];
const neutral700 = constants.colors.ui.neutral[700];

export const challengesAmountOfTokensCss = {
  color: neutral700,
};

export const challengesInfoTextCss = {
  ...textSObj,
  color: neutral500,
};
